<template>
  <button
    @click="$emit('click')"
    type="button"
    class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-orange-400 hover:bg-orange-300 focus:outline-none focus:border-orange-400 focus:shadow-outline-orange active:bg-orange-400 transition ease-in-out duration-150"
  >
    <font-awesome-icon
      v-if="icon"
      :icon="icon"
      class="fa-fw nav-icon mr-1"
    ></font-awesome-icon>
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "BaseButtonWarning",
  props: ["icon"],
};
</script>
